// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"styles_tabContainer__tfyNf","tabRow":"styles_tabRow__p8YBJ","filler":"styles_filler__3kIIe"};